import http from '../http'
const API_URL = "branch_offices"

class BranchOfficeAPI {
  async createBranchOffice(BranchOffice) {
    const response = await http(`${API_URL}/save`, 'POST', BranchOffice)
    return response
  }
  async getAllBranchOffice() {
    const response = await http(`${API_URL}`)
    return response
  } 
 
  async getBranchOffice(branchOffice) {
    const response = await http(`${API_URL}/show/${branchOffice}`)
    return response
  }

  async getBranchOfficeByCompany(companyID, page) {
    const response = await http(`${API_URL}/company/${companyID}?page=${page}`)
    return response || null
  }

  async getNotPaginate(companyID) {
    const response = await http(`${API_URL}/company/not_paginate/${companyID}`)
    return response
  }

  async updateBranchOffice(idBranchOffice, branchOffice) {
    const response = await http(`${API_URL}/update/${idBranchOffice}`, 'PUT', branchOffice)
    return response
  }

  async deleteBranchOffice(idBranchOffice) {
    const response = await http(`${API_URL}/delete/${idBranchOffice}`, 'DELETE')
    return response
  }

  
}

export default new BranchOfficeAPI()